var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    {
      staticClass: "viq-sidebar",
      class: {
        "viq-sidebar--collapsed": _vm.collapsed,
        "viq-sidebar--open": !_vm.collapsed,
      },
    },
    [
      !_vm.collapsed
        ? [
            _c("div", { staticClass: "viq-sidebar__header" }, [
              _c(
                "button",
                {
                  staticClass: "viq-sidebar__new-btn",
                  on: { click: _vm.newConversation },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M7 1v12M1 7h12",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                        },
                      }),
                    ]
                  ),
                  _vm._v("\n        New Chat\n      "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "viq-sidebar__collapse-btn",
                  attrs: { title: "Collapse sidebar" },
                  on: { click: _vm.toggleSidebar },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M11 4L6 9l5 5",
                          stroke: "currentColor",
                          "stroke-width": "1",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M7 4L2 9l5 5",
                          stroke: "currentColor",
                          "stroke-width": "1",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "viq-sidebar__sections" }, [
              _vm.lensesEnabled
                ? _c("div", { staticClass: "viq-sidebar__section" }, [
                    _c(
                      "div",
                      {
                        staticClass: "viq-sidebar__section-header",
                        on: {
                          click: function ($event) {
                            _vm.lensesExpanded = !_vm.lensesExpanded
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "viq-sidebar__section-left" },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "viq-sidebar__section-icon",
                                attrs: {
                                  width: "14",
                                  height: "14",
                                  viewBox: "0 0 14 14",
                                  fill: "none",
                                },
                              },
                              [
                                _c("ellipse", {
                                  attrs: {
                                    cx: "7",
                                    cy: "7",
                                    rx: "6",
                                    ry: "3",
                                    stroke: "currentColor",
                                    "stroke-width": "1.2",
                                  },
                                }),
                                _vm._v(" "),
                                _c("circle", {
                                  attrs: {
                                    cx: "7",
                                    cy: "7",
                                    r: "1.5",
                                    fill: "currentColor",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "viq-sidebar__section-title" },
                              [_vm._v("LENSES")]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "viq-sidebar__section-actions" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "Lenses let you focus VIQ on specific regulatory areas",
                                  placement: "top",
                                  "open-delay": 400,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "viq-sidebar__help-badge" },
                                  [_vm._v("?")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "svg",
                              {
                                staticClass: "viq-sidebar__chevron",
                                class: {
                                  "viq-sidebar__chevron--expanded":
                                    _vm.lensesExpanded,
                                },
                                attrs: {
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 12 12",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M4 5l2 2 2-2",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.lensesExpanded
                      ? _c(
                          "div",
                          { staticClass: "viq-sidebar__section-content" },
                          [
                            _c("ViqLensSelector"),
                            _vm._v(" "),
                            _vm.mode === "lens-build"
                              ? _c("ViqLensBuilder")
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "viq-sidebar__divider" }),
              _vm._v(" "),
              _c("div", { staticClass: "viq-sidebar__section" }, [
                _c(
                  "div",
                  {
                    staticClass: "viq-sidebar__section-header",
                    on: {
                      click: function ($event) {
                        _vm.interactionsExpanded = !_vm.interactionsExpanded
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "viq-sidebar__section-left" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "viq-sidebar__section-icon",
                          attrs: {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 14 14",
                            fill: "none",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M12 9a1.5 1.5 0 01-1.5 1.5H4.5L2 13V3.5A1.5 1.5 0 013.5 2h7A1.5 1.5 0 0112 3.5V9z",
                              stroke: "currentColor",
                              "stroke-width": "1.2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "viq-sidebar__section-title" },
                        [_vm._v("INTERACTIONS")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "viq-sidebar__section-actions" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "Your conversation history",
                              placement: "top",
                              "open-delay": 400,
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "viq-sidebar__help-badge" },
                              [_vm._v("?")]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.conversationCount > 0
                          ? _c(
                              "span",
                              { staticClass: "viq-sidebar__count-badge" },
                              [_vm._v(_vm._s(_vm.conversationCount))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "viq-sidebar__chevron",
                            class: {
                              "viq-sidebar__chevron--expanded":
                                _vm.interactionsExpanded,
                            },
                            attrs: {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 12 12",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M4 5l2 2 2-2",
                                stroke: "currentColor",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.interactionsExpanded
                  ? _c(
                      "div",
                      { staticClass: "viq-sidebar__section-content" },
                      [_c("ViqConversationList")],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ]
        : [
            _c("div", { staticClass: "viq-sidebar__collapsed-strip" }, [
              _c(
                "button",
                {
                  staticClass: "viq-sidebar__expand-btn",
                  attrs: { title: "Expand sidebar" },
                  on: { click: _vm.toggleSidebar },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M7 4l5 5-5 5",
                          stroke: "currentColor",
                          "stroke-width": "1",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M11 4l5 5-5 5",
                          stroke: "currentColor",
                          "stroke-width": "1",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "viq-sidebar__collapsed-new",
                  attrs: { title: "New Chat" },
                  on: { click: _vm.newConversation },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M7 1v12M1 7h12",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "viq-sidebar__collapsed-avatars" },
                _vm._l(_vm.collapsedAvatars, function (conv) {
                  return _c(
                    "span",
                    {
                      key: conv.id,
                      staticClass: "viq-sidebar__collapsed-avatar",
                      class: {
                        "viq-sidebar__collapsed-avatar--active":
                          _vm.activeConversation &&
                          _vm.activeConversation.id === conv.id,
                      },
                      attrs: { title: conv.title },
                      on: {
                        click: function ($event) {
                          return _vm.selectConversation(conv)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            conv.title
                              ? conv.title.charAt(0).toLowerCase()
                              : "?"
                          ) +
                          "\n        "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }